import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './000c42ca305291142266f5779267d2cd1f0ecd948ac70fc4562b87a43c07d288.cfe-internal.js';
import '../../icons/index.es.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useComboboxContext } from './b31cf09859637ddcb4d1a4a83c806ba39869aadedd96320b532d4c7939067785.cfe-internal.js';
import ChevronDownIcon from '../../icons/components/7c7c780956cb4e93fe69a1384927ee5fbe6526f5bb2422c9d44843841947bab7.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["className", "onClick", "onMouseDown", "size"];
var ComboboxIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useComboboxContext = useComboboxContext(),
    isOpen = _useComboboxContext.isOpen,
    setIsOpen = _useComboboxContext.setIsOpen,
    inputRef = _useComboboxContext.inputRef,
    iconRef = _useComboboxContext.iconRef,
    disabled = _useComboboxContext.disabled;
  return /*#__PURE__*/React__default.createElement(ChevronDownIcon, _extends({}, rest, {
    size: size,
    className: classNames(styles.comboboxIcon, className, _defineProperty(_defineProperty({}, styles.open, isOpen), styles.disabled, disabled)),
    onClick: !disabled ? wrapEvent(onClick, function () {
      if (inputRef.current === document.activeElement) {
        setIsOpen(!isOpen);
      } else {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      }
    }) : undefined,
    onMouseDown: wrapEvent(onMouseDown, function (e) {
      return e === null || e === void 0 ? void 0 : e.preventDefault();
    }),
    ref: mergeRefs(ref, iconRef),
    "aria-hidden": "true"
  }));
});

export { ComboboxIcon as default };
